// extracted by mini-css-extract-plugin
export default {"FavoriteSession":"FavoriteSession-module-d18d16e48cc3af6d4c6e","favorite":"FavoriteSession-module-f9332a51b833099411d3"};